export default "__VITE_ASSET__lboRntpR__"